import { FloatingCtaRoot } from './FloatingCta.styles'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'

export const FloatingCta = () => {
  const { t } = useTranslation()

  return (
    <FloatingCtaRoot>
      <Text>{t('recipes-overview:floating-cta.title')}</Text>
      <Link passHref href="/meal-plan">
        <Button>{t('recipes-overview:floating-cta.button')}</Button>
      </Link>
    </FloatingCtaRoot>
  )
}

FloatingCta.displayName = 'FloatingCta'
